import React, { ReactElement } from 'react';
import ContactArea from './ContactArea';
import TabArea from './TabArea';

const InfoArea: React.FC = (): ReactElement => (
  <div className="flex flex-col justify-between w-full max-w-3xl h-24 ml-8">
    <ContactArea />
    <TabArea />
  </div>
);

export default InfoArea;
